import IFlagsmith from 'flagsmith';
import { Flags } from 'flagsmith-nodejs';
import React from 'react';

// sort flags alphabetically to match flag-smith order
export const DefaultFlagsContext = {
  // These two are permanent flags, we use these to rollout flags
  // to our dogfood and launchpad segments.
  EnableAlphaApps: false,
  EnableBetaApps: false,

  EnableManyCompanies: true, // Permanently enabled - no longer checks Flagsmith
  EnableFolderLocking: false,
  EnableRootFolderLocking: false,
  EnableSubscriptionEditSummary: false,
  EnableAppSetup: false,
  EnableAppSetupUIUpdates: false,
};

export type FlagContextType = typeof DefaultFlagsContext;

export const getServerFlagsContextValue = (flags: Flags) => ({
  EnableAlphaApps: flags.isFeatureEnabled('enable_alpha_apps'),
  EnableBetaApps: flags.isFeatureEnabled('enable_beta_apps'),
  EnableManyCompanies: true, // Permanently enabled - no longer checks Flagsmith
  EnableFolderLocking: flags.isFeatureEnabled('enable_folder_locking'),
  EnableRootFolderLocking: flags.isFeatureEnabled('enable_root_folder_locking'),
  EnableSubscriptionEditSummary: flags.isFeatureEnabled(
    'subscription_edit_summary',
  ),
  EnableAppSetup: flags.isFeatureEnabled('enable_app_setup'),
  EnableAppSetupUIUpdates: flags.isFeatureEnabled(
    'enable_app_setup_ui_updates',
  ),
});

export const getClientFlagsContextValue = (flags: typeof IFlagsmith) => ({
  EnableAlphaApps: flags.hasFeature('enable_alpha_apps'),
  EnableBetaApps: flags.hasFeature('enable_beta_apps'),
  EnableManyCompanies: true, // Permanently enabled - no longer checks Flagsmith
  EnableFolderLocking: flags.hasFeature('enable_folder_locking'),
  EnableRootFolderLocking: flags.hasFeature('enable_root_folder_locking'),
  EnableSubscriptionEditSummary: flags.hasFeature('subscription_edit_summary'),
  EnableAppSetup: flags.hasFeature('enable_app_setup'),
  EnableAppSetupUIUpdates: flags.hasFeature('enable_app_setup_ui_updates'),
});

export const FlagsContext = React.createContext(DefaultFlagsContext);
